import { colors } from "@commonsku/styles";
import React from "react";
import { DisplayUser } from "../../types";
import Avatar from "../helpers/Avatar";
import { AgentAvatarIcon } from "../helpers/AgentAvatarIcon";

export const UserAvatar = ({ user }: { user: DisplayUser }) => {
    if (user.userType === 'AGENT') {
        return <AgentAvatarIcon size={24} style={{ marginRight: 10 }} />;
    }

    return (
        <Avatar
            name={`${user.firstName} ${user.lastName}`}
            user_image_paths={user.avatarImagePath ? { small: user.avatarImagePath } : {}}
            backgroundColor={colors.teal["main"]}
            style={{
              height: 24,
              width: 24,
              fontSize: "0.75rem",
              paddingRight: 0,
            }}
        />
    );
};
